import { PageHeader } from 'components/PageHeader';
import { getTrans } from 'modules/i18n';

export const AvailabilityHeader = () => (
  <PageHeader title={getTrans('availabilityPage.title')} withBackBtn />
);
